"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAlignableWidget = exports.isResizeableWidget = exports.hasTrait = exports.getTraitConfig = exports.getGenericConfigByType = exports.getConfigByType = void 0;
var Chevron_1 = __importDefault(require("Public/Widgets/Chevron"));
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var chevronStyles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Chevron/ChevronWidget.css"));
var lodash_1 = require("lodash");
var Box_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Box"));
var QuoteSummary_1 = __importDefault(require("@CommonFrontend/Public/Widgets/QuoteSummary"));
var classnames_1 = __importDefault(require("classnames"));
var Video_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Video"));
var MediaVariable_1 = require("@CommonFrontend/ContentTokens/Models/MediaVariable");
var Models_1 = require("@CommonFrontend/ContentTokens/Models");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var styles = __importStar(require("./CommonWidgetRegistry.css"));
var Embed_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Embed"));
var partiallyApplyComponent_1 = __importDefault(require("@CommonFrontend/QuoteV2/Components/partiallyApplyComponent"));
var QuoteSummaryWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSummary/QuoteSummaryWidget");
var ROICalculator_1 = __importDefault(require("@CommonFrontend/Public/Widgets/ROICalculator"));
var ROICalculatorUtils_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorUtils");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var GoogleMaps_1 = __importDefault(require("@CommonFrontend/Public/Widgets/GoogleMaps"));
var ListItem_1 = require("@CommonFrontend/ContentTokens/TokenRenderers/ListItem");
var Image_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Image/Image"));
var Widgets_1 = require("@CommonFrontend/Public/Widgets");
var uuid_1 = require("uuid");
var SideBySide_1 = require("@CommonFrontend/Public/Widgets/SideBySide/SideBySide");
__exportStar(require("./TokenCreators"), exports);
var makeConfig = function (config) { return config; };
var configs = [
    makeConfig({
        type: "chevron",
        tokenType: {},
        publicRender: function (_a) {
            var _b;
            var token = _a.token, attributes = _a.attributes;
            return server_1.default.renderToString(react_1.default.createElement(Chevron_1.default, { attributes: attributes, clickToScroll: (_b = token.clickToScroll) !== null && _b !== void 0 ? _b : true }));
        },
        traits: {
            styleable: {
                styleKey: "chevron",
                properties: [
                    { name: "backgroundColor", label: "Background color", type: "color", var: chevronStyles.backgroundColor },
                ],
            },
        },
    }),
    makeConfig({
        type: "box",
        tokenType: {},
        publicRender: function (_a) {
            var token = _a.token, renderTokens = _a.renderTokens, attributes = _a.attributes;
            return server_1.default.renderToString(react_1.default.createElement(Box_1.default, {
                columns: [renderTokens(token.columns[0]), renderTokens(token.columns[1])],
                attributes: attributes,
            }));
        },
        flattenForComments: function (currentToken, flattenedTokens) {
            (0, lodash_1.flattenDeep)(currentToken.columns).forEach(function (t) { return flattenedTokens.push(t); });
        },
        tokenTraversers: {
            getFlatFromListOfTokens: function (token, runFlat) {
                var _a, _b, column, _c, _d, columnToken, e_1_1, e_2_1;
                var e_2, _e, e_1, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0: return [4, token];
                        case 1:
                            _g.sent();
                            _g.label = 2;
                        case 2:
                            _g.trys.push([2, 13, 14, 15]);
                            _a = __values(token.columns), _b = _a.next();
                            _g.label = 3;
                        case 3:
                            if (!!_b.done) return [3, 12];
                            column = _b.value;
                            _g.label = 4;
                        case 4:
                            _g.trys.push([4, 9, 10, 11]);
                            _c = (e_1 = void 0, __values(runFlat(column))), _d = _c.next();
                            _g.label = 5;
                        case 5:
                            if (!!_d.done) return [3, 8];
                            columnToken = _d.value;
                            return [4, columnToken];
                        case 6:
                            _g.sent();
                            _g.label = 7;
                        case 7:
                            _d = _c.next();
                            return [3, 5];
                        case 8: return [3, 11];
                        case 9:
                            e_1_1 = _g.sent();
                            e_1 = { error: e_1_1 };
                            return [3, 11];
                        case 10:
                            try {
                                if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                            return [7];
                        case 11:
                            _b = _a.next();
                            return [3, 3];
                        case 12: return [3, 15];
                        case 13:
                            e_2_1 = _g.sent();
                            e_2 = { error: e_2_1 };
                            return [3, 15];
                        case 14:
                            try {
                                if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                            return [7];
                        case 15: return [2];
                    }
                });
            },
            getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
                var transformedColumns = [unpackAndTransformFn(token.columns[0]), unpackAndTransformFn(token.columns[1])];
                token.columns = transformedColumns;
                return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
            },
        },
        traits: {
            resizeable: {
                width: {
                    wide: true,
                    custom: false,
                    default: "wide",
                },
                handleDirections: "ew",
            },
        },
    }),
    makeConfig({
        publicRender: function (_a) {
            var attributes = _a.attributes;
            return "<hr class=\"".concat((0, classnames_1.default)(attributes.className), "\" />");
        },
        tokenType: {},
        type: "horizontalRule",
        traits: {
            spacingShim: {
                className: "horizontal-rule-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        type: "quoteSummary",
        tokenType: {},
        publicRender: function QuoteSummaryWidget(_a) {
            var _b, _c, _d, _e, _f;
            var attributes = _a.attributes, token = _a.token;
            return server_1.default.renderToString(react_1.default.createElement((0, partiallyApplyComponent_1.default)(QuoteSummary_1.default, {
                attributes: attributes,
                settings: {
                    showFeatureLists: (_b = token.showFeatureLists) !== null && _b !== void 0 ? _b : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showFeatureLists,
                    showTextItems: (_c = token.showTextItems) !== null && _c !== void 0 ? _c : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showTextItems,
                    showPlanSectionHeaders: (_d = token.showPlanSectionHeaders) !== null && _d !== void 0 ? _d : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showPlanSectionHeaders,
                    compactLineItemDescriptions: (_e = token.compactLineItemDescriptions) !== null && _e !== void 0 ? _e : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactLineItemDescriptions,
                    compactSectionHeaders: (_f = token.compactSectionHeaders) !== null && _f !== void 0 ? _f : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactSectionHeaders,
                },
            })));
        },
        traits: {},
    }),
    makeConfig({
        type: "heading1",
        tokenType: {},
        publicRender: function (_a) {
            var attributes = _a.attributes, innerHtml = _a.innerHtml;
            if (innerHtml === "" || /^<span[^>]*><\/span>$/.test(innerHtml)) {
                innerHtml = "<br />";
            }
            return "<h1 class=\"".concat(attributes.className, "\">").concat(innerHtml, "</h1>");
        },
        traits: {
            spacingShim: {
                className: "h1-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        type: "heading2",
        tokenType: {},
        publicRender: function (_a) {
            var attributes = _a.attributes, innerHtml = _a.innerHtml;
            if (innerHtml === "" || /^<span[^>]*><\/span>$/.test(innerHtml)) {
                innerHtml = "<br />";
            }
            return "<h2 class=\"".concat(attributes.className, "\">").concat(innerHtml, "</h2>");
        },
        traits: {
            spacingShim: {
                className: "h2-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        type: "paragraph",
        tokenType: {},
        publicRender: function (_a) {
            var attributes = _a.attributes, innerHtml = _a.innerHtml;
            if (innerHtml === "" || /^<span[^>]*><\/span>$/.test(innerHtml)) {
                innerHtml = "<br />";
            }
            return "<p class=\"".concat(attributes.className, "\">").concat(innerHtml, "</p>");
        },
        traits: {
            spacingShim: {
                className: "p-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        type: "listItem",
        tokenType: {},
        publicRender: function (_a) {
            var token = _a.token, innerHtml = _a.innerHtml, index = _a.index, tokens = _a.tokens;
            return (0, ListItem_1.createHtmlFromListItem)(token, { innerHtml: innerHtml, index: index, tokens: tokens });
        },
        traits: {
            spacingShim: {
                className: "listitem-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        type: "blockQuote",
        tokenType: {},
        publicRender: function (_a) {
            var attributes = _a.attributes, innerHtml = _a.innerHtml;
            if (innerHtml === "" || /^<span[^>]*><\/span>$/.test(innerHtml)) {
                innerHtml = "<br />";
            }
            return "<blockquote class=\"".concat(attributes.className, "\">").concat(innerHtml, "</blockquote>");
        },
        traits: {
            spacingShim: {
                className: "blockquote-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        publicRender: function (_a) {
            var attributes = _a.attributes, token = _a.token, isPrintMode = _a.isPrintMode, publicPageLink = _a.publicPageLink;
            if (!(0, exports.isResizeableWidget)(token)) {
                throw new Error("Video widget is resizeable");
            }
            return server_1.default.renderToString(react_1.default.createElement(Video_1.default, {
                attributes: attributes,
                embedUrl: token.embedUrl,
                width: token.width,
                isPrintMode: isPrintMode,
                publicPageLink: publicPageLink,
            }));
        },
        tokenType: {},
        type: "video",
        traits: {
            resizeable: {
                width: {
                    custom: true,
                    wide: true,
                    default: "content",
                },
                handleDirections: "corners",
            },
            mediaVariable: {
                toMediaVariableToken: function (token) {
                    var nextToken = __assign(__assign(__assign({}, (0, lodash_1.cloneDeep)(token)), { media: MediaVariable_1.Media.Video, subType: Models_1.BlockType.MediaVariable, label: token.variable.label, name: token.variable.name }), (0, CommonUtils_1.includeIf)(!!token.variable.substitutionToken, {
                        substitutionToken: token.variable.substitutionToken,
                    }));
                    delete nextToken.displayUrl;
                    delete nextToken.embedUrl;
                    delete nextToken.variable;
                    return nextToken;
                },
            },
            spacingShim: {
                className: "video-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        publicRender: function (_a) {
            var token = _a.token, index = _a.index, attributes = _a.attributes;
            var text = token.text, href = token.href;
            var hrefAttributes = !!href && (0, URL_1.isURL)(href, true) ? "href=\"".concat(href, "\" target=\"_blank\" rel=\"noopener\"") : "href=\"#\"";
            var html = "\n  <div class=\"button-widget__container ".concat((0, classnames_1.default)(attributes.className, styles.buttonWidgetContainer), "\">\n  <div class=\"button-widget button-widget__render\">\n    <a data-qwilr-component-idx=\"").concat(index, "\" data-qwilr-component=\"button-component\" ").concat(hrefAttributes, ">\n      <div class=\"button-widget__button center\">\n        <div class=\"button-widget__button-text user-font\">\n          ").concat(text, "\n        </div>\n      </div>\n    </a>\n  </div>\n  </div>\n  ");
            return html;
        },
        tokenType: {},
        type: "button",
        traits: {
            alignable: {
                defaultAlignment: "center",
            },
            spacingShim: {
                className: "button-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        publicRender: function (_a) {
            var attributes = _a.attributes, token = _a.token, isPrintMode = _a.isPrintMode;
            if (!(0, exports.isResizeableWidget)(token)) {
                throw new Error("Embed widget is resizeable");
            }
            return server_1.default.renderToString(react_1.default.createElement(Embed_1.default, {
                attributes: attributes,
                embedUrl: token.embedUrl,
                width: token.width,
                isPrintMode: isPrintMode,
            }));
        },
        tokenType: {},
        type: "iframe",
        traits: {
            resizeable: {
                width: {
                    custom: true,
                    wide: true,
                    default: "content",
                    minInPx: 128,
                },
                height: {
                    default: 63,
                    minInPx: 128,
                },
                handleDirections: "corners",
            },
            mediaVariable: {
                toMediaVariableToken: function (token) {
                    var nextToken = __assign(__assign(__assign({}, (0, lodash_1.cloneDeep)(token)), { media: MediaVariable_1.Media.Iframe, subType: Models_1.BlockType.MediaVariable, label: token.variable.label, name: token.variable.name }), (0, CommonUtils_1.includeIf)(!!token.variable.substitutionToken, {
                        substitutionToken: token.variable.substitutionToken,
                    }));
                    delete nextToken.embedUrl;
                    delete nextToken.embedPreset;
                    delete nextToken.variable;
                    return nextToken;
                },
            },
            spacingShim: {
                className: "embed-widget__spacing-shim",
            },
            alignable: {
                defaultAlignment: "center",
            },
        },
    }),
    makeConfig({
        publicRender: function (_a) {
            var _b;
            var token = _a.token, isPrintMode = _a.isPrintMode, disableImgix = _a.disableImgix, attributes = _a.attributes;
            return server_1.default.renderToString(react_1.default.createElement(ROICalculator_1.default, {
                payload: {
                    inputs: (_b = token.inputs) !== null && _b !== void 0 ? _b : {},
                    slider: token.slider,
                    roiResult: token.roiResult,
                    title: token.title,
                    description: token.description,
                    backgroundImageUrl: (0, ROICalculatorUtils_1.getOptimisedRoiBackgroundImageUrl)({
                        backgroundImageUrl: token.backgroundImageUrl,
                        disableImgix: !!disableImgix,
                        isPrintMode: isPrintMode,
                    }),
                    useStaticRangeInput: !!isPrintMode,
                    id: (0, utils_1.randomString)(),
                },
                attributes: attributes,
            }));
        },
        tokenType: {},
        traits: {
            spacingShim: {
                className: styles.roiCalculatorSpacingShim,
            },
        },
        type: "roiCalculator",
    }),
    makeConfig({
        publicRender: function (_a) {
            var attributes = _a.attributes, token = _a.token, isPrintMode = _a.isPrintMode;
            if (!(0, exports.isResizeableWidget)(token)) {
                throw new Error("Google maps widget is resizeable");
            }
            return server_1.default.renderToString(react_1.default.createElement(GoogleMaps_1.default, { embedUrl: token.embedUrl, width: token.width, attributes: attributes, isPrintMode: isPrintMode }));
        },
        type: "googleMaps",
        tokenType: {},
        traits: {
            resizeable: { handleDirections: "corners", width: { custom: true, wide: true, minInPx: 280, default: 100 } },
            mediaVariable: {
                toMediaVariableToken: function (token) {
                    var nextToken = __assign(__assign(__assign({}, (0, lodash_1.cloneDeep)(token)), { media: MediaVariable_1.Media.GoogleMaps, subType: Models_1.BlockType.MediaVariable, label: token.variable.label, name: token.variable.name }), (0, CommonUtils_1.includeIf)(!!token.variable.substitutionToken, {
                        substitutionToken: token.variable.substitutionToken,
                    }));
                    delete nextToken.displayUrl;
                    delete nextToken.embedUrl;
                    delete nextToken.variable;
                    return nextToken;
                },
            },
            spacingShim: {
                className: "google-maps-widget__spacing-shim",
            },
        },
    }),
    makeConfig({
        type: "image",
        tokenType: {},
        publicRender: function (_a) {
            var token = _a.token, attributes = _a.attributes, disableImgix = _a.disableImgix, isPrintMode = _a.isPrintMode, sideBySideConfig = _a.sideBySideConfig, printOrientation = _a.printOrientation;
            return server_1.default.renderToString(react_1.default.createElement(Image_1.default, {
                token: token,
                attributes: attributes,
                options: {
                    disableImgix: disableImgix,
                    isPrintMode: isPrintMode,
                    printOrientation: printOrientation,
                    sideBySide: sideBySideConfig,
                },
            }));
        },
        traits: {
            resizeable: {
                width: { custom: true, wide: true, default: 100, minInPx: 50 },
                handleDirections: "corners",
            },
            alignable: { defaultAlignment: "center" },
            spacingShim: {
                className: "image-widget__spacing-shim",
            },
            mediaVariable: {
                toMediaVariableToken: function (token) {
                    var nextToken = __assign(__assign(__assign({}, (0, lodash_1.cloneDeep)(token)), { media: MediaVariable_1.Media.Image, subType: Models_1.BlockType.MediaVariable, label: token.variable.label, name: token.variable.name }), (0, CommonUtils_1.includeIf)(!!token.variable.substitutionToken, {
                        substitutionToken: token.variable.substitutionToken,
                    }));
                    delete nextToken.variable;
                    delete nextToken.src;
                    return nextToken;
                },
            },
        },
    }),
    makeConfig({
        type: "accordion",
        publicRender: function (props) {
            var _a;
            return server_1.default.renderToString(react_1.default.createElement(Widgets_1.Accordion, {
                id: (0, uuid_1.v4)(),
                heading: props.renderTokens(props.token.heading),
                body: props.renderTokens(props.token.body),
                backgroundImageUrl: props.token.backgroundImageUrl,
                isPrintMode: (_a = props.isPrintMode) !== null && _a !== void 0 ? _a : false,
                widgetAttributes: props.attributes,
            }));
        },
        tokenType: {},
        traits: {
            spacingShim: { className: "accordion-widget__spacing-shim" },
        },
        flattenForComments: function (currentToken, flattenedTokens) {
            (0, lodash_1.flattenDeep)([currentToken.heading, currentToken.body]).forEach(function (accordionToken) {
                flattenedTokens.push(accordionToken);
            });
        },
        tokenTraversers: {
            getFlatFromListOfTokens: function (token, runFlat) {
                var _a, _b, headingToken, e_3_1, _c, _d, bodyToken, e_4_1;
                var e_3, _e, e_4, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0: return [4, token];
                        case 1:
                            _g.sent();
                            _g.label = 2;
                        case 2:
                            _g.trys.push([2, 7, 8, 9]);
                            _a = __values(runFlat(token.heading)), _b = _a.next();
                            _g.label = 3;
                        case 3:
                            if (!!_b.done) return [3, 6];
                            headingToken = _b.value;
                            return [4, headingToken];
                        case 4:
                            _g.sent();
                            _g.label = 5;
                        case 5:
                            _b = _a.next();
                            return [3, 3];
                        case 6: return [3, 9];
                        case 7:
                            e_3_1 = _g.sent();
                            e_3 = { error: e_3_1 };
                            return [3, 9];
                        case 8:
                            try {
                                if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                            }
                            finally { if (e_3) throw e_3.error; }
                            return [7];
                        case 9:
                            _g.trys.push([9, 14, 15, 16]);
                            _c = __values(runFlat(token.body)), _d = _c.next();
                            _g.label = 10;
                        case 10:
                            if (!!_d.done) return [3, 13];
                            bodyToken = _d.value;
                            return [4, bodyToken];
                        case 11:
                            _g.sent();
                            _g.label = 12;
                        case 12:
                            _d = _c.next();
                            return [3, 10];
                        case 13: return [3, 16];
                        case 14:
                            e_4_1 = _g.sent();
                            e_4 = { error: e_4_1 };
                            return [3, 16];
                        case 15:
                            try {
                                if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                            }
                            finally { if (e_4) throw e_4.error; }
                            return [7];
                        case 16: return [2];
                    }
                });
            },
            getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
                token.heading = unpackAndTransformFn(token.heading);
                token.body = unpackAndTransformFn(token.body);
                return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
            },
        },
    }),
    makeConfig({
        type: "sideBySide",
        tokenType: {},
        publicRender: function (props) { return server_1.default.renderToString(react_1.default.createElement(SideBySide_1.SideBySide, props)); },
        flattenForComments: function (currentToken, flattenedTokens) {
            (0, lodash_1.flattenDeep)([currentToken.column1, currentToken.column2]).forEach(function (t) { return flattenedTokens.push(t); });
        },
        tokenTraversers: {
            getFlatFromListOfTokens: function (token, runFlat) {
                var _a, _b, column, _c, _d, columnToken, e_5_1, e_6_1;
                var e_6, _e, e_5, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0: return [4, token];
                        case 1:
                            _g.sent();
                            _g.label = 2;
                        case 2:
                            _g.trys.push([2, 13, 14, 15]);
                            _a = __values([token.column1, token.column2]), _b = _a.next();
                            _g.label = 3;
                        case 3:
                            if (!!_b.done) return [3, 12];
                            column = _b.value;
                            _g.label = 4;
                        case 4:
                            _g.trys.push([4, 9, 10, 11]);
                            _c = (e_5 = void 0, __values(runFlat(column))), _d = _c.next();
                            _g.label = 5;
                        case 5:
                            if (!!_d.done) return [3, 8];
                            columnToken = _d.value;
                            return [4, columnToken];
                        case 6:
                            _g.sent();
                            _g.label = 7;
                        case 7:
                            _d = _c.next();
                            return [3, 5];
                        case 8: return [3, 11];
                        case 9:
                            e_5_1 = _g.sent();
                            e_5 = { error: e_5_1 };
                            return [3, 11];
                        case 10:
                            try {
                                if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                            }
                            finally { if (e_5) throw e_5.error; }
                            return [7];
                        case 11:
                            _b = _a.next();
                            return [3, 3];
                        case 12: return [3, 15];
                        case 13:
                            e_6_1 = _g.sent();
                            e_6 = { error: e_6_1 };
                            return [3, 15];
                        case 14:
                            try {
                                if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                            }
                            finally { if (e_6) throw e_6.error; }
                            return [7];
                        case 15: return [2];
                    }
                });
            },
            getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
                token.column1 = unpackAndTransformFn(token.column1);
                token.column2 = unpackAndTransformFn(token.column2);
                return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
            },
        },
        traits: {
            resizeable: {
                width: {
                    wide: true,
                    custom: false,
                    default: "wide",
                    fullBleedOnMobile: false,
                },
                handleDirections: "ew",
            },
            spacingShim: {
                className: "side-by-side-widget__spacing-shim",
            },
            skipContainerAnimation: {},
            showWidgetOutlineOnHover: {},
        },
    }),
    makeConfig({
        type: "contentLoop",
        tokenType: {},
        publicRender: function () {
            return "";
        },
        flattenForComments: function (currentToken, flattenedTokens) {
            (0, lodash_1.flattenDeep)([currentToken.content]).forEach(function (contentLoopToken) {
                flattenedTokens.push(contentLoopToken);
            });
        },
        tokenTraversers: {
            getFlatFromListOfTokens: function (token, runFlat) {
                var _a, _b, childToken, e_7_1;
                var e_7, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4, token];
                        case 1:
                            _d.sent();
                            _d.label = 2;
                        case 2:
                            _d.trys.push([2, 7, 8, 9]);
                            _a = __values(runFlat(token.content)), _b = _a.next();
                            _d.label = 3;
                        case 3:
                            if (!!_b.done) return [3, 6];
                            childToken = _b.value;
                            return [4, childToken];
                        case 4:
                            _d.sent();
                            _d.label = 5;
                        case 5:
                            _b = _a.next();
                            return [3, 3];
                        case 6: return [3, 9];
                        case 7:
                            e_7_1 = _d.sent();
                            e_7 = { error: e_7_1 };
                            return [3, 9];
                        case 8:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_7) throw e_7.error; }
                            return [7];
                        case 9: return [2];
                    }
                });
            },
            getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
                token.content = unpackAndTransformFn(token.content);
                return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
            },
        },
        traits: {
            spacingShim: {
                className: "content-loop__spacing-shim",
            },
        },
    }),
];
var getConfigByType = function (type) {
    var e_8, _a;
    try {
        for (var configs_1 = __values(configs), configs_1_1 = configs_1.next(); !configs_1_1.done; configs_1_1 = configs_1.next()) {
            var config = configs_1_1.value;
            if (config.type === type) {
                return config;
            }
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (configs_1_1 && !configs_1_1.done && (_a = configs_1.return)) _a.call(configs_1);
        }
        finally { if (e_8) throw e_8.error; }
    }
    throw new Error("Config with type ".concat(type, " not registered"));
};
exports.getConfigByType = getConfigByType;
var getGenericConfigByType = function (type) {
    try {
        return (0, exports.getConfigByType)(type);
    }
    catch (_a) {
        return undefined;
    }
};
exports.getGenericConfigByType = getGenericConfigByType;
var getTraitConfig = function (_a) {
    var widgetType = _a.widgetType, traitName = _a.traitName;
    return (0, exports.getConfigByType)(widgetType).traits[traitName];
};
exports.getTraitConfig = getTraitConfig;
var hasTrait = function (_a) {
    var widgetType = _a.widgetType, traitName = _a.traitName;
    return traitName in (0, exports.getConfigByType)(widgetType).traits;
};
exports.hasTrait = hasTrait;
var isResizeableWidget = function (token) {
    return !!(0, exports.getTraitConfig)({ widgetType: token.subType, traitName: "resizeable" });
};
exports.isResizeableWidget = isResizeableWidget;
var isAlignableWidget = function (token) {
    return !!(0, exports.getTraitConfig)({ widgetType: token.subType, traitName: "alignable" });
};
exports.isAlignableWidget = isAlignableWidget;
